/**
 * Google Translate cookie helpers for custom language switch integration.
 * Uses googtrans cookie: format /sourceLanguage/targetLanguage (e.g. /fr/en)
 */

export const setGoogleTranslateLanguage = (targetLang) => {
  const expiry = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
  const isFrench = targetLang === 'fr';
  const cookieValue = isFrench ? '' : `/fr/${targetLang}`;
  const expiresStr = isFrench
    ? 'expires=Thu, 01 Jan 1970 00:00:00 GMT'
    : `expires=${expiry.toUTCString()}`;

  // Build the list of domain variants to set/clear cookies on
  const hostname = window.location.hostname;
  const bare = hostname.replace(/^www\./, '');
  const domains = ['', hostname, `.${hostname}`, bare, `.${bare}`];

  // Clear existing googtrans cookies on all domain variants
  domains.forEach(dom => {
    const domPart = dom ? `; domain=${dom}` : '';
    // Always include path=/  (Bug fix: was missing path on the second clear line)
    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domPart}`;
  });

  // Set new cookie across all domain variants so Google Translate picks it up
  if (!isFrench) {
    domains.forEach(dom => {
      const domPart = dom ? `; domain=${dom}` : '';
      document.cookie = `googtrans=${cookieValue}; ${expiresStr}; path=/${domPart}`;
    });
  }

  // Keep localStorage in sync — clear it for French (native), set it for others
  // Bug fix: previously localStorage was always written, including for French,
  // which caused it to permanently override the cookie reader on next load.
  if (isFrench) {
    localStorage.removeItem('user-language');
  } else {
    localStorage.setItem('user-language', targetLang);
  }

  window.location.reload();
};

export const getCurrentLanguageFromCookie = () => {
  // Bug fix: previously localStorage was checked first unconditionally, meaning
  // the googtrans cookie was never consulted. Now we validate localStorage only
  // when it holds a non-French value AND the cookie actually agrees, to avoid
  // stale localStorage overriding a cleared/changed cookie.
  const localLang = localStorage.getItem('user-language');

  // Parse the cookie regardless so we can cross-check
  const rawCookie = document.cookie.match(/googtrans=([^;]+)/);
  const rawValue = rawCookie ? decodeURIComponent(rawCookie[1].trim()) : '';
  const isCookieActive = rawValue && rawValue !== '/fr' && rawValue !== '/fr/fr';

  if (isCookieActive) {
    // Cookie is set — extract the target language from /source/target
    const parts = rawValue.split('/');
    return parts[parts.length - 1] || 'fr';
  }

  // No active cookie — trust localStorage only if it explicitly stores a
  // non-French language (edge case: tab restored before cookie loaded)
  if (localLang && localLang !== 'fr') {
    return localLang;
  }

  return 'fr';
};
